module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/vkovalcuk29239528-bkg-7fe4a54fb6b8bbc67745a080bb1e1d05.jpg";